<template>
  <div class="bank-customers-page">
    <bank-navbar/>
    <b-container class="bg-white shadow-sm p-4">
      <h2>Bank Customers</h2>
      <h3>{{ currentBank.name }}</h3>

      <hr>

      <h3>Customers</h3>

      <section v-if="customerList.length">
        <p v-for="customer in customerList" :key="customer.id"><router-link :to="'/customers/'+customer.id">{{ customer.name }}</router-link></p>
      </section>
      <section v-else>
        <p><em>No customers.</em></p>
      </section>

      <hr>

      <h3>New Customer</h3>

      <b-form-group label="Customer Name">
        <b-form-input ref="newCustomerName" v-model="newCustomerForm.name" trim @keyup.enter="addNewCustomer"></b-form-input>
      </b-form-group>

      <b-form-group label="Customer Email">
        <b-form-input ref="newCustomerEmail" v-model="newCustomerForm.email" trim @keyup.enter="addNewCustomer"></b-form-input>
      </b-form-group>

      <b-form-group label="Customer Company Name">
        <b-form-input ref="newCustomerCompanyName" v-model="newCustomerForm.company_name" trim @keyup.enter="addNewCustomer"></b-form-input>
      </b-form-group>

      <b-form-group label="Customer Phone Number">
        <b-form-input ref="newCustomerPhone" v-model="newCustomerForm.phone_number" trim @keyup.enter="addNewCustomer"></b-form-input>
      </b-form-group>

      <b-button variant="primary" @click="addNewCustomer">+ Add Customer</b-button>

    </b-container>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import BankNavbar from '@/components/BankNavbar.vue'

export default {
  name: 'BankCustomers',
  components: {
    BankNavbar
  },
  data () {
    return {
      customerList: [],
      newCustomerForm: {
        name:         '',
        email:        '',
        company_name: '',
        bank_id:      null,
        phone_number: '',
      }
    }
  },
  computed: {
    ...mapGetters([
      'currentBank',
    ])
  },
  methods: {
    ...mapActions([
      'getCustomers',
      'postNewCustomer'
    ]),

    async loadCustomers () {
      const result = await this.getCustomers()
      if (result.success) {
        this.customerList = result.data
      }
    },

    async addNewCustomer () {
      console.log('addNewCustomer', this.newCustomerForm)
      if (!this.newCustomerForm.name) {
        this.$refs.newCustomerName.focus()
        return
      }
      if (!this.newCustomerForm.email) {
        this.$refs.newCustomerEmail.focus()
        return
      }
      if (!this.newCustomerForm.company_name) {
        this.$refs.newCustomerCompanyName.focus()
        return
      }
      if (!this.newCustomerForm.phone_number) {
        this.$refs.newCustomerPhone.focus()
        return
      }
      const result = await this.postNewCustomer({
        name:         this.newCustomerForm.name,
        username:     this.newCustomerForm.email,
        company_name: this.newCustomerForm.company_name,
        phone_number: this.newCustomerForm.phone_number,
        bank_id:      this.currentBank.id,
      })
      console.log('  result', result)
      if (result.success) {
        this.loadCustomers()
      }
    },

  },
  async mounted () {
    console.log('BankCustomers.mounted')
    console.log('  currentBank', this.currentBank)
    if (this.currentBank) {
      this.loadCustomers()
    }
  },
  watch: {
    async currentBank (newVal, oldVal) {
      console.log('currentBank changed', oldVal, newVal)
      if (oldVal === null && newVal !== null) {
        this.loadCustomers()
      }
    }
  }
}
</script>

<style scoped>
</style>
